import type { JSX } from "react";
import { useRouteError } from "react-router";
import { Button } from "@/ui/button.js";

export function RouteErrorScreen(): JSX.Element {
  const error = useRouteError();
  // The one place a raw error should reach the console.
  console.error("route error", error);
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center gap-4 bg-zinc-950 text-zinc-50 p-6 text-center">
      <h1 className="text-lg font-medium">Something went wrong</h1>
      <p className="text-sm text-zinc-400">Your data is safe. Reloading usually fixes it.</p>
      <Button onClick={() => { window.location.reload(); }}>Reload</Button>
      <a href="/recipes" className="text-sm text-emerald-400 underline-offset-4 hover:underline">Back to library</a>
    </div>
  );
}
